
export enum DialogType {
    ALERT = "alert",
}

export interface FactoryDialogProps extends AlertProps{
    type: DialogType;
}

export interface AlertActions extends AlertButtonActions {
    title: string;
    content: string;
    confirm: string;
    cancel?: string;
    colorButton?: string;
    isMessage?: boolean

}

export interface AlertButtonActions {
    onConfirm?: () => void;
    onCancel?: () => void;
}

export type AlertProps = {
    isOpen: boolean;
    actions: AlertActions;
    onClose: () => void;
}